import { render, staticRenderFns } from "./ContratoSupporter.vue?vue&type=template&id=c6befabc&scoped=true&lang=pug&"
import script from "./ContratoSupporter.vue?vue&type=script&lang=js&"
export * from "./ContratoSupporter.vue?vue&type=script&lang=js&"
import style0 from "./ContratoSupporter.vue?vue&type=style&index=0&id=c6befabc&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6befabc",
  null
  
)

export default component.exports